<div class="language-dropdown">
  <i *ngIf="showGlobeIcon" class="pi pi-globe p-button-icon"></i>
  <p-dropdown 
    [options]="languages" 
    [(ngModel)] = "selectedLanguage"
    optionLabel="name" 
    (onChange)="onChanged($event.value)"
    class="language-dropdown-menu">
  </p-dropdown>
</div>